import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import AppHeader from "@/components/AppHeader";
import { Button } from "@/components/ui/button";
import { K, card, EMPTY_ITEM, itemBody, useCatalogueConfig } from "@/lib/catalogue";
import ItemForm from "@/components/inventory/ItemForm";

export default function ItemNew() {
  const navigate = useNavigate();
  const cfg = useCatalogueConfig();
  const [form, setForm] = useState({ ...EMPTY_ITEM });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    if (!form.item_name.trim()) return toast.error("Give the item a name");
    setSaving(true);
    try { const { data } = await axios.post(`${K}/items`, itemBody(form)); toast.success("Item saved — add a photo and sources"); navigate(`/inventory/items/${data.id}`); }
    catch (e) { toast.error("Could not save", { description: typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Check the fields" }); }
    finally { setSaving(false); }
  };
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 pb-28 md:pb-8">
      <AppHeader />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-3" data-testid="item-new-page">
        <div className="flex items-center justify-between gap-3">
          <Link to="/inventory" className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-violet-300" data-testid="item-back"><ArrowLeft className="w-3.5 h-3.5" /> Catalogue</Link>
          <span className="text-[10px] uppercase tracking-[0.2em] text-violet-400 font-bold">New item</span>
        </div>
        <div><h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">Save an item</h1><p className="text-xs text-slate-500 mt-1">Name + category is enough to start. Photo, sources and checklist are added on the item page.</p></div>
        <div className={`${card} p-4`}><ItemForm form={form} setForm={setForm} cfg={cfg} /></div>
        <div className="flex justify-end gap-2"><Button variant="outline" onClick={() => navigate(-1)} className="h-9 border-slate-700 bg-transparent" data-testid="item-cancel">Cancel</Button><Button onClick={save} disabled={saving} data-testid="item-create" className="h-9 px-5 bg-violet-500 hover:bg-violet-400 text-slate-950 font-bold">{saving ? "Saving…" : "Save item"}</Button></div>
      </main>
    </div>
  );
}
